import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { StyledGuestsFilter } from '@rentivo/gatsby-core/src/containers/SearchProvider/components/filters/GuestsFilter/styles';

export const StyledGuestsPicker = styled(StyledGuestsFilter)`
  
`;
